import { FaCrown, FaCaretLeft } from "react-icons/fa";
// import { FaCaretRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import Card from "../../UI/Card";
import { SectionHead } from "../index";
import { useTranslation } from "react-i18next";
import { SiOpenaigym } from "react-icons/si";
import "./programs.css";
const Programs = () => {
  const { t, ready } = useTranslation();
  if (!ready) return "loading ...";
  const products = t("products", { returnObjects: true });

  return (
    <section className="programs">
      <div className="container programs__container">
        <SectionHead icon={<FaCrown />} title={t("products_title")} />

        <div className="programs__wrapper">
          {products.map(({ id, icon, title, info, path }) => {
            return (
              <Card className="programs__program" key={id}>
                <span>
                  <SiOpenaigym />
                </span>
                <h4>{title}</h4>
                <small>{info}</small>
                <Link to={path} className="btn sm">
                  {t("see_btn")}
                  <FaCaretLeft />
                </Link>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Programs;
